(() => {
  const root = document.getElementById('commander-le-masque');
  const source = document.querySelector('[data-lc22-lp-variants]');
  if (!root || !source || root.dataset.lc22VariantBound) return;
  let variants;
  try { variants = JSON.parse(source.textContent); } catch { return; }
  root.dataset.lc22VariantBound = 'true';
  // Keep this featured-product picker local to the LP. The theme's default
  // fetch targets the product page, which can reset its selected product.
  root.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement) || target.type !== 'radio' || !target.closest('variant-picker')) return;
    const variant = variants.find(item => String(item.id) === target.dataset.variantId);
    if (!variant) return;
    event.stopImmediatePropagation();
    const form = target.closest('product-form');
    if (!form) return;
    form.querySelectorAll('input[name="id"]').forEach(input => { input.value = variant.id; });
    const pickerData = target.closest('variant-picker').querySelector('script[type="application/json"]');
    if (pickerData) pickerData.textContent = JSON.stringify(variant);
    const price = form.querySelector('[data-ref="add-to-cart-button-container"]');
    if (price) {
      price.dataset.price = variant.price;
      price.dataset.compareAtPrice = variant.compare_at_price || variant.price;
    }
    const button = form.querySelector('[data-ref="add-to-cart-button"]');
    if (button) button.disabled = !variant.available;
    if (typeof form.onFormUpdated === 'function') form.onFormUpdated();
    const image = variant.featured_media?.preview_image?.src;
    if (image) {
      const thumb = [...root.querySelectorAll('.splide__slide img')].find(img => img.src.split('?')[0].endsWith(image.split('?')[0].split('/').pop()));
      const control = thumb?.closest('button');
      if (control) control.click();
    }
  }, true);
})();
